import { createGameAnalyticsDimensions } from 'App/Services/Analytics/game/createGameAnalyticsDimensions';

export const gaPresetValues = {
    GaCurrencies: 'Key,Coin',
    GaItemTypes:
        'ADS,BuySkin,CompleteLevel,Cheat,MultiplyPanel,OpenChest,Offer',
};
export const gaCustomDimensions = createGameAnalyticsDimensions();
